import React from 'react';

const AUDIENCES = [
  'Traditional Rental Agencies',
  'Digital Rental Agencies',
  'Marketplace / Turo Hosts',
  'Ride Share Rental Fleets',
  'New to Rental Industry',
  'Enterprise Accounts',
];

const FEATURES = [
  'Automated Bookings',
  'Trust & Safety Tools',
  'Insurance & Protection',
  'Resolution & Support',
  'AI Agent Assistance',
  'Training & Education',
];

const AboutSection = () => (
  <section className="icrs-about">
    <div className="icrs-container icrs-container--narrow icrs-about__inner">
      <p className="icrs-section-label">About Rentid</p>
      <h2 className="icrs-about__heading">
        We are an all-in-one rental commerce platform, empowering modern operators.
      </h2>

      {/* Two pill groups side by side with a divider between */}
      <div className="icrs-about__grid">
        <div>
          <p className="icrs-about__col-label">All of Rental Supported</p>
          <div className="icrs-pill-group">
            {AUDIENCES.map((item) => (
              <span key={item} className="icrs-tag">{item}</span>
            ))}
          </div>
        </div>

        <div className="icrs-about__divider" />

        <div>
          <p className="icrs-about__col-label">Automated Back Office Workflows</p>
          <div className="icrs-pill-group">
            {FEATURES.map((item) => (
              <span key={item} className="icrs-tag icrs-tag--dark">{item}</span>
            ))}
          </div>
        </div>
      </div>

      <div className="icrs-about__cta">
        <a
          href="https://rentid.io"
          target="_blank"
          rel="noopener noreferrer"
          className="icrs-cta-btn"
        >
          Reserve Time with Rentid at ICRS 2026
        </a>
      </div>

      <div className="icrs-about__ailink">
        <a
          href="https://rentid.io/ai-agents"
          target="_blank"
          rel="noopener noreferrer"
          className="icrs-textlink"
        >
          Learn more about Rentid Human In The Loop AI Agents
        </a>
      </div>
    </div>
  </section>
);

export default AboutSection;
